export default __webpack_public_path__ + "static/media/magic.5e466c4e.png";